module.exports = __webpack_public_path__ + "img/ecli.7273f81e.svg";